import { Eyebrow, PrimaryButton, Reveal } from "@/components/ui-bits";

const NotSure = () => {
  return (
    <section data-testid="not-sure-section" aria-labelledby="not-sure-heading" className="border-t border-[#e5e7eb] bg-white py-16 sm:py-20">
      <div className="container-30 max-w-3xl">
        <Reveal>
          <Eyebrow>Not Sure What You Need?</Eyebrow>
          <h2
            id="not-sure-heading"
            data-testid="not-sure-headline"
            className="mt-6 font-display text-3xl font-extrabold leading-[1.08] tracking-tight text-[#191c1e] sm:text-4xl"
          >
            TELL US WHAT YOU'RE MOVING. WE'LL HELP DETERMINE THE RIGHT SOLUTION.
          </h2>
          <p className="mt-6 text-base leading-relaxed text-[#5f666d] sm:text-lg">
            Don't know which transportation service is right? Tell us about your freight, pickup and delivery
            requirements, and our logistics specialists can help determine the most appropriate transportation solution.
          </p>
          <div className="mt-10">
            <PrimaryButton to="/request-a-quote" testid="not-sure-cta">
              REQUEST A QUOTE
            </PrimaryButton>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default NotSure;
